export const handleNotification = (notifyType, assetApproved, approvalQty = 'N/A') => {
  if (notifyType === 'success') {
    const approvalVerb = assetApproved ? t('Approved') : t('Unapproved');
    const approvalCopy = approvalQty === 1 ? t('total approval') : t('total approvals');
    const bodyText = (approvalQty === 'N/A' || !approvalQty)
      ? ''
      : `${t('This asset requires')} ${approvalQty} ${approvalCopy}. ${assetApproved ? t('All previous approvals are void.') : ''}`;

    Notify.create({
      title: `${approvalVerb} ${t('1 asset')}!`,
      body: bodyText,
      type: 'success'
    });
  }

  if (notifyType === 'error') {
    const approvingErrorCopy = t('An error occurred when approving assets.');
    const unapprovingErrorCopy = t('An error occurred when unapproving assets.');

    Notify.create({
      title: `${assetApproved ? approvingErrorCopy : unapprovingErrorCopy} ${t('Please try again.')}`,
      type: 'error'
    });
  }
};

export const sweetAlertUnapproveOptions = {
  title: t('This asset has external links.'),
  text: t('Are you sure you want to unapprove? Unapproving will cause broken image links on sites that depend on the availability of this asset. Check the usage tab to see active external links before unapproving.\n\n'),
  type: 'warning',
  showCancelButton: true,
  cancelButtonText: 'Cancel',
  confirmButtonText: 'Unapprove',
  closeOnConfirm: true,
  customClass: 'merging'
};
